import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=00b6ad95"
import script from "./NotificationEdit.vue?vue&type=script&lang=js"
export * from "./NotificationEdit.vue?vue&type=script&lang=js"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=00b6ad95&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports